import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MapService } from '../../services/map/map.service';
import { MapBoxSync } from '../../helpers/mapBoxSync';
import * as mapboxgl from 'mapbox-gl';
import { SplitViewComponent } from '../../components/split-view/split-view.component';
import { GenericTypeService } from 'src/app/services/generic-type/generic-type.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { LayerStoreService } from 'src/app/stores/layer-store/layer-store.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

import * as xml2js from 'xml-js';
import { stringify } from 'querystring';
import { OpenlayerService } from 'src/app/services/openlayer/openlayer.service';
import { OpenLayerAnnotation } from 'src/app/components/openlayer/openlayer.component';
import { ActivatedRoute, Router } from '@angular/router';

declare var qx;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.sass'],
})
export class MapComponent implements OnInit, OnDestroy {
  @ViewChild(SplitViewComponent, { static: false })
  mapSplitView: SplitViewComponent;

  unsubber: Subject<boolean> = new Subject<boolean>();

  map: mapboxgl.Map;
  style = 'mapbox://styles/intuitivebadger/ckfdel5j40z8p19o6o0xu05sd';
  lat = 0;
  lng = 0;
  zoom = 4;
  genericTypeServiceSub: Subscription;
  localMannheimBentleyAsset = '../assets/3d-mesh/mannheim/App/index.html';
  localSumitomoBentleyAsset = '../assets/3d-mesh/sumitomo/App/index.html';
  localAerodyneBentleyAsset = '../assets/3d-mesh/aerodyne/App/index.html';
  localCJPTanjungJatiBentleyAsset = '../assets/3d-mesh/tanjungjati-b/App/index.html';

  isEmbed: boolean = false;
  embedUrl: SafeResourceUrl;
  embedUrlBentley: SafeResourceUrl;

  showFacade: boolean = false;
  facade;
  openlayerDrawmode = 'None';
  zoomifyWidth: number = 7276;
  zoomifyHeight: number = 90000;
  zoomifyUrl: string =
    'https://dmql6z22jzc51.cloudfront.net/zoomify/5c4fee4c36c3d3794d400f12/1548815922319/ImageProperties.xml';
  deleteSelected: string;
  openlayerAnnot: OpenLayerAnnotation = {};
  savedDrawings;
  zoomFitToFeature;
  isOlEditEnable;
  openlayerDrawColor;

  constructor(
    public mapService: MapService,
    private genericTypeService: GenericTypeService,
    private layerStore: LayerStoreService,
    private domSanitizer: DomSanitizer,
    private splitViewService: SplitViewService,
    private locationStore: LocationStoreService,
    private openlayerService: OpenlayerService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    /*

    BASE MAP IS NOW BUILT BY SPLIT VIEW COMPONENT
    with onBaseMapReady and onBaseMapLoaded callback

    */

    // this.mapService.buildMap(
    //   {
    //     container: 'map',
    //     style: this.style,
    //     zoom: this.zoom,
    //     center: [138.290445, 35.822435],
    //     pitch: 60
    //   },
    //   true
    // );
    //this.mapService.deckIsActive = true;
    //this.mapService.loadSingle3DTilesDeckLayer("170706", aerodynePointCloudMeta); // aerodyne
    //this.mapService.loadSingle3DTilesDeckLayer("170061", suntoryPointCloudMeta); // suntory

    // this.mapService.currZoom$.subscribe((res) => (this.zoom = res));

    // this.mapService.map.on('zoom', () => {
    //   this.mapService.currZoom$.next(this.mapService.map.getZoom().toFixed(2));
    // });

    // this.mapService.map.on('load', () => {
    //   // this.mapService.map.on('mousemove', (e) => {
    //   // })

    //   this.mapService.buildDraw()
    //   this.mapService.isMapLoaded$.next(true);
    //   this.mapService.showCoordinateLocation();
    //   this.mapService.buildDeck();
    //   this.mapService.isDeckLoaded$.next(true);
    // });
    this.mapService.isThreeDMesh$.subscribe((res) => {
      /** WIP: cannot find way to re-init 3d mesh */
      // if (res) {
      //   const threeDMesh = this.dataService.currentLocation.map_layer.find(
      //     (i) => i.layer_type === '3d-mesh'
      //   );
      //   const eu = threeDMesh.external_url.substr(0,threeDMesh.external_url.lastIndexOf('/'))
      //   fetch(
      //     `${eu}/config.json`,
      //     { method: 'get' }
      //   )
      //     .then((response) => {
      //       return response.json();
      //     })
      //     .then((json) => {
      //       const URLs = json.URLs.map(i => {
      //         const su = i.scene.replace('..','')
      //         return {
      //           ...i, scene: eu.substr(0,eu.lastIndexOf('/')) + su
      //         }
      //       })
      //       qx.$$loader.init([...URLs], 'bentleyContainer');
      //     })
      //     .catch(function (err) {

      //       document.getElementById('bentleyContainer').innerHTML =
      //       '<iframe src="' +
      //       this.localMannheimBentleyAsset +
      //       '" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>';
      //     });
      // } else if (res === false) {
      //   qx.$$loader.destroy()
      //   // window.location.replace(window.location.href.split('#')[0])
      // }

      /** alternative hardcoded */
      if (res) {
        const curLoc = this.locationStore.currLocation$.getValue();
        if (curLoc.id === '5fd20851acc1ba265bf878b4') {
          // mannheim id
          document.getElementsByClassName('bentleyContainer')[0].innerHTML =
            '<iframe src="' +
            this.localMannheimBentleyAsset +
            '" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>';
        } else if (curLoc.id === '5ff59b5b7bc5bc1ce308cf4b') {
          // sumitomo id
          document.getElementsByClassName('bentleyContainer')[0].innerHTML =
            '<iframe src="' +
            this.localSumitomoBentleyAsset +
            '" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>';
        } else if (curLoc.id === '5ffd655aa0be0327b3555a85') {
          // aerodyne id
          document.getElementsByClassName('bentleyContainer')[0].innerHTML =
            '<iframe src="' +
            this.localAerodyneBentleyAsset +
            '" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>';
        } else if (curLoc.id === '642230f268214eb9766ca607') {
          // cjp pltu tanjung jati b 2024 id
          document.getElementsByClassName('bentleyContainer')[0].innerHTML =
            '<iframe src="' +
            this.localCJPTanjungJatiBentleyAsset +
            '" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>';
        }
      } else if (document.getElementsByClassName('bentleyContainer')[0]) {
        document.getElementsByClassName('bentleyContainer')[0].innerHTML = '';
      }
    });
    this.layerStore.isEmbed$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.isEmbed = res;
      });
    this.layerStore.embedLayerFilter$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((el) => {
        if (el && el.length > 0) {
          const embedLayer = this.layerStore.embedLayers$.getValue();
          this.embedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
            embedLayer.find((i) => i.id === el[0]).external_url
          );
        } else {
          this.embedUrl = null;
        }
      });
    this.layerStore.orthoManyLayerFilter$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((el) => {
        // console.log('ortho many layer MAP', el);
      });
    this.layerStore.geojsonLayerFilter$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((el) => {
        if (el && el.length > 0) {
          let geojsonLayer = this.layerStore.geojsonLayers$.getValue();
          let filtered = geojsonLayer.filter((i) => el.includes(i.id));
          filtered.forEach((i) => {
            fetch(i.external_url)
              .then((res) => res.json())
              .then((res) => {
                let geojson = res;

                if (geojson.default) {
                  for (let c = 0; c < geojson.default.features.length; c++) {
                    if (i.fill_color) {
                      geojson.default.features[c].properties['_f_color'] =
                        geojson.default.features[c].properties['_c_color'] =
                          i.fill_color;
                    }
                    if (i.line_color) {
                      geojson.default.features[c].properties['_f_o_color'] =
                        geojson.default.features[c].properties['_l_color'] =
                        geojson.default.features[c].properties['_c_s_color'] =
                          i.line_color;
                    }
                    if (i.line_width) {
                      geojson.default.features[c].properties['_l_width'] =
                        geojson.default.features[c].properties['_c_s_width'] =
                          parseInt(i.line_width);
                    }
                  }
                } else {
                  for (let c = 0; c < geojson.features.length; c++) {
                    if (i.fill_color) {
                      geojson.features[c].properties['_f_color'] =
                        geojson.features[c].properties['_c_color'] =
                          i.fill_color;
                    }
                    if (i.line_color) {
                      geojson.features[c].properties['_f_o_color'] =
                        geojson.features[c].properties['_l_color'] =
                        geojson.features[c].properties['_c_s_color'] =
                          i.line_color;
                    }
                    if (i.line_width) {
                      geojson.features[c].properties['_l_width'] =
                        geojson.features[c].properties['_c_s_width'] = parseInt(
                          i.line_width
                        );
                    }
                  }
                }

                this.mapService.loadGeoJsons(geojson, undefined, i.id);
              });
          });
        } else {
          this.mapService.removeGeoJsons(undefined, 'all');
        }
      });

    this.layerStore.isFacade$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (!res) {
          this.showFacade = false;
          this.zoomFitToFeature = undefined;
          this.openlayerDrawmode = 'None';
          this.savedDrawings = undefined;
          this.openlayerAnnot = {};
        } else {
          fetch(res.external_url)
            .then((response) => response.text())
            .then((data) => {
              const { HEIGHT, WIDTH } = JSON.parse(
                xml2js.xml2json(data, { compact: true })
              ).IMAGE_PROPERTIES._attributes;

              this.zoomifyWidth = WIDTH;
              this.zoomifyHeight = HEIGHT;
              this.zoomifyUrl = res.external_url;
              this.savedDrawings =
                this.openlayerService.allSavedAnnot$.getValue();
              this.openlayerAnnot.openlayerScreenshot = null;
              this.openlayerAnnot.maplayerid = res.id;
              this.openlayerService.currentAnnot$.next(this.openlayerAnnot);
              this.showFacade = true;
            });
        }
      });

    this.openlayerService.drawMode$.subscribe((mode) => {
      this.openlayerDrawmode = mode;
    });

    this.openlayerService.deleteSelectedAnnot$.subscribe(
      (d) => (this.deleteSelected = d)
    );
    this.openlayerService.savedAnnot$.subscribe((sa) => {
      this.savedDrawings = sa.openlayerDrawings;
      if (sa.zoomFitToFeature) {
        this.zoomFitToFeature = sa.zoomFitToFeature;
      }
      if (sa.enableEdit) {
        this.isOlEditEnable = sa.enableEdit;
      }
    });
    this.openlayerService.drawingColor$.subscribe(
      (color) => (this.openlayerDrawColor = color)
    );
    this.openlayerService.allSavedAnnot$.subscribe((d) => {
      this.savedDrawings = d;
    });
  }

  getDeckVisibility() {
    if (this.mapService.deckIsActive) {
      return 'block';
    } else {
      return 'none';
    }
  }

  mapSyncMove(length = 3): MapBoxSync {
    const mapArr = [];

    for (let i = 0; i < length; i++) {
      const map = this.mapService.buildMap({
        container: `map${i}`,
        style: this.style,
        zoom: this.zoom,
        center: [this.lng, this.lat],
        preserveDrawingBuffer: true,
      });

      map.on('load', () => {
        this.mapService.addOrtho(
          {
            external_url:
              'https://aerodyne-mco-data.s3.ap-southeast-1.amazonaws.com/Sungai%20Langat/Maptiler/Sungai%20Langat/index.html',
          },
          'id',
          map
        );
      });

      mapArr.push(map);
    }

    return new MapBoxSync(...mapArr);
  }

  // this is attached to split view component as a callback
  onBaseMapReady(baseMap: mapboxgl.Map) {
    const baseMapState = {
      latitude: baseMap.getCenter().lat,
      longitude: baseMap.getCenter().lng,
      zoom: baseMap.getZoom(),
      bearing: baseMap.getBearing(),
      pitch: baseMap.getPitch(),
      preserveDrawingBuffer: true,
    };

    this.mapService.setBaseMap(baseMap, baseMapState);

    this.genericTypeServiceSub = this.genericTypeService
      .findAll([
        { key: 'filtered[0][key]', val: 'category' },
        { key: 'filtered[0][val]', val: 'severity' },
      ])
      .subscribe((res) => {
        this.mapService.buildDraw(res.data);
      });
  }

  // this is attached to split view component as a callback
  onBaseMapLoaded(baseMap: mapboxgl.Map) {
    this.mapService.showCoordinateLocation();
    this.mapService.buildDeck();
    this.mapService.isDeckLoaded$.next(true);

    this.mapService.isMapLoaded$.next(true);
    const maps: mapboxgl.Map[] = this.splitViewService.mapViews.map(
      (mapView) => mapView.map
    ); // this will return active maps in the split view
  }

  onNewMapAdded(newMap: mapboxgl.Map) {
    const maps: mapboxgl.Map[] = this.splitViewService.mapViews.map(
      (mapView) => mapView.map
    ); // this will return active maps in the split view
  }

  onLastMapRemoved() {
    const maps: mapboxgl.Map[] = this.splitViewService.mapViews.map(
      (mapView) => mapView.map
    ); // this will return active maps in the split view
    if (maps.length === 1)
      this.splitViewService.onEvent$.next({ isSplitscreenOn: false });
  }

  ngOnDestroy() {
    this.unsubber.next();
    this.unsubber.unsubscribe();
  }

  onDrawingsChanges($event): void {
    this.openlayerAnnot.openlayerDrawings = $event;
    this.openlayerService.currentAnnot$.next(this.openlayerAnnot);
  }

  onOpenlayerDrawEnd($event): void {
    this.openlayerService.drawMode$.next('None');
  }

  onScreenshotCaptured($event) {
    this.openlayerAnnot.openlayerScreenshot = $event;
    this.openlayerService.currentAnnot$.next(this.openlayerAnnot);
  }

  onFeaturesClicked($event) {
    const props = $event[0].getProperties();
    if (!props.location_id) return;
    this.router
      .navigate([`/projects/${props.location_id}/details/annotations`], {
        relativeTo: this.activatedRoute,
      })
      .then(() => {
        const annotationCard = document.getElementById(
          `annotation-card-${props.annotation_id}`
        );
        if (annotationCard) {
          const annotationCardOffset = annotationCard.offsetTop;
          const annotationContainer = document.getElementById(
            'list-annotation-container'
          );

          annotationContainer.scrollTo({
            top: annotationCardOffset,
            behavior: 'smooth',
          });
        }
      });
  }
}
